import React from 'react';
import classnames from 'classnames';

import PropTypes from 'prop-types';

import { formatNumeric } from '../../../../util';

import styles from './index.scss';
import { ConfigData } from '../../../../util/ABUtil';

/**
 * LoadingFigureSection
 * @returns {*}
 * @constructor
 */
const LoadingFigureSection = () => {
  return (
    <div className={classnames('row', styles.figuresSection)}>
      <div className={classnames('col-md-12', styles.figuresContainer)}>
        <h5 className={styles.messageItem}>Loading figures...</h5>
      </div>
    </div>
  );
};
/**
 * NoDataFigureSection
 * @param onReload
 * @returns {*}
 * @constructor
 */
const NoDataFigureSection = ({ onReload }) => {
  return (
    <div className={classnames('row', styles.figuresSection)}>
      <div className={classnames('col-md-12', styles.figuresContainer)}>
        <h5 className={styles.messageItem}>
          No data is present for the period selected.
          <br />
          <a className={styles.retryLink} onClick={onReload}>
            Click here to fetch figure data again.
          </a>
        </h5>
      </div>
    </div>
  );
};
/**
 * FigureItem
 * @param current
 * @param previous
 * @param title
 * @param isPercentage
 * @returns {*}
 * @constructor
 */
const FigureItem = ({ current, previous, title, isPercentage }) => {
  let caretClass = '';
  let fontAwesomeCaretClass = '';

  if (current === previous) {
    caretClass = '';
    fontAwesomeCaretClass = '';
  }

  if (current > previous) {
    caretClass = styles.caretUp;
    fontAwesomeCaretClass = 'fa fa-caret-up';
  }

  if (current < previous) {
    caretClass = styles.caretDown;
    fontAwesomeCaretClass = 'fa fa-caret-down';
  }

  return (
    <div className={styles.figureItem}>
      <p className={styles.figureTitle}>{title}</p>
      <p className={styles.figureCount}>
        {isPercentage
          ? Number(formatNumeric(current)).toFixed(2)
          : formatNumeric(current)}{' '}
        {isPercentage ? '%' : ''}{' '}
        <i className={classnames(fontAwesomeCaretClass, caretClass)}></i>
      </p>
      <p className={styles.previousFigureCount}>
        {isPercentage
          ? Number(formatNumeric(previous)).toFixed(2)
          : formatNumeric(previous)}{' '}
        {isPercentage ? '%' : ''}
      </p>
    </div>
  );
};
/**
 * FiguresSection
 * @param props
 * @returns {*}
 * @constructor
 */
export const FiguresSection = (props) => {
  const { data, isLoading, onReload } = props;

  if (isLoading) {
    return <LoadingFigureSection />;
  }

  if (data) {
    const { current, previous } = data;
    let formattedFigures = {};

    // Iterate keys for formatting in current figures
    Object.keys(current).forEach((currentKeys) => {
      formattedFigures[currentKeys] = { current: current[currentKeys] };
    });

    // Iterate keys for formatting in previous figures
    Object.keys(previous).forEach((previousKeys) => {
      formattedFigures[previousKeys] = {
        ...formattedFigures[previousKeys],
        previous: previous[previousKeys]
      };
    });
    return (
      <div className={classnames('row', styles.figuresSection)}>
        <div className={classnames('col-md-12', styles.figuresContainer)}>
          <FigureItem
            current={
              formattedFigures?.transactions?.current
                ? formattedFigures.transactions.current
                : 0
            }
            previous={
              formattedFigures?.transactions?.previous
                ? formattedFigures.transactions.previous
                : 0
            }
            title="No. of Transactions"
          />

          <FigureItem
            current={
              formattedFigures?.alerts?.current
                ? formattedFigures.alerts.current
                : 0
            }
            previous={
              formattedFigures?.alerts?.previous
                ? formattedFigures.alerts.previous
                : 0
            }
            title="Alerts"
          />

          {!ConfigData.IS_NCD_NOT_AVAILABLE && (
            <FigureItem
              current={
                formattedFigures?.anomalies?.current
                  ? formattedFigures.anomalies.current
                  : 0
              }
              previous={
                formattedFigures?.anomalies?.previous
                  ? formattedFigures.anomalies.previous
                  : 0
              }
              title="Anomalies"
            />
          )}

          <FigureItem
            current={
              formattedFigures?.noIssue?.current
                ? formattedFigures.noIssue.current
                : 0
            }
            previous={
              formattedFigures?.noIssue?.previous
                ? formattedFigures.noIssue.previous
                : 0
            }
            title={ConfigData.IS_NCD_NOT_AVAILABLE ? 'Non STR' : 'No Issue'}
          />

          <FigureItem
            current={
              formattedFigures?.str?.current ? formattedFigures.str.current : 0
            }
            previous={
              formattedFigures?.str?.previous
                ? formattedFigures.str.previous
                : 0
            }
            title="STR"
          />

          <FigureItem
            isPercentage={true}
            current={
              formattedFigures?.l1?.current
                ? formattedFigures.l1.current * 100
                : 0
            }
            previous={
              formattedFigures?.l1?.previous
                ? formattedFigures.l1.previous * 100
                : 0
            }
            title="L1 Alerts"
          />
        </div>
      </div>
    );
  }

  return <NoDataFigureSection onReload={onReload} />;
};
/**
 * FiguresSection
 * @type {{isLoading: shim, data: shim, onReload: shim}}
 */
FiguresSection.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.func,
  onReload: PropTypes.func
};
